import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { Popup } from "react-leaflet";
import getDates from "../../../shared/services/date.service";
import Scrollbars from "react-custom-scrollbars-2";
import { v4 as uuidv4 } from "uuid";

class WinterMaintenceRouteUnitMapPoup extends Component {
  getPointContentitem(point, unit) {
    const isDump = point["DU1"] !== undefined && point["DU1"].toLowerCase() === "true";
    const isSand = point["SAND"] !== undefined && point["SAND"].toLowerCase() === "true";

    return (
      <div className={styles.pointDataPoupupContentItem}>
        <div>{getDates.getDateFormat3(point["TI"])}</div>
        <div className={styles.params}>
          <div>скр: {point["SPEE"]}</div>
          {isDump ? <div>ОТВ опущен;</div> : unit.isDumpSensor ? <div>ОТВ поднят;</div> : null}
          {isSand ? <div>ППС сыпит;</div> : unit.isSandSensor ? <div>ППС не сыпит;</div> : null}
        </div>
      </div>
    );
  }

  getContentItem(unit, point) {
    return (
      <div key={uuidv4()} className={styles.unitPoupupContent}>
        <div style={{ minWidth: "160px" }}>{unit.companyTitle}</div>
        <div style={{ minWidth: "120px" }}>
          <div>
            <b>
              <a href={`/cars/${unit.id}/intimerange`} target="_blank" rel="noreferrer">
                {unit.registerNumber}
              </a>
            </b>
          </div>
          <div> {unit.title}</div>
        </div>

        <div style={{ minWidth: "540px" }}>
          <div className={styles.unitPointsPoupupContent}>
          {this.getPointContentitem(point, unit)}
          </div>
        </div>

        <div style={{ minWidth: "200px" }}>
          {unit.groups.length === 0
            ? "Вне групп"
            : unit.groups.map((x) => {
                return <div key={x.id}>{x.title}</div>;
              })}
        </div>
      </div>
    );
  }

  getHeader() {
    return (
      <div className={styles.unitPoupupContent}>
        <div style={{ minWidth: "160px" }}>Организация</div>
        <div style={{ minWidth: "120px" }}>Гос. номер</div>
        <div style={{ minWidth: "540px" }}>Данные в радиусе 300 метров</div>
        <div style={{ minWidth: "200px" }}>Группы</div>
      </div>
    );
  }

  render() {
    const { point, unit } = this.props;

    return (
      <Popup className="mapPopup" closeButton={true} position={[parseFloat(point["COOY"]), parseFloat(point["COOX"])]}>
        <div className="mapPopupContent" style={{ fontSize: "11px", fontWeight: "600" }}>
          {this.getHeader()}
        </div>

        <div className="mapPopupContent" style={{ fontSize: "10px" }}>
          <Scrollbars ref="scrollbar" style={{ height: "200px" }} autoHide={false}>
            {this.getContentItem(unit, point)}
          </Scrollbars>
        </div>
      </Popup>
    );
  }
}

export default React.memo(WinterMaintenceRouteUnitMapPoup);
